import { EventBus } from '@/event-bus';
import { generic_storage } from '../_utilities/generic_storage';
import { folderService } from '../_services';

const extendedFolderStore = generic_storage('folderService');

extendedFolderStore.state = {
  ...extendedFolderStore.state,
  allFolderImage: '',
  sharedCollageImage: '',
};

extendedFolderStore.actions = {
  ...extendedFolderStore.actions,
  updateItem({ commit }, { folderId, payload }) {
    commit('setIsLoading', true);
    folderService.patchItem(folderId, payload).then((response) => {
      commit('updateItem', response.data);
      commit('setIsLoading', false);
    }).catch(() => {
      EventBus.$emit('toast-error', 'Couldn\'t update folder information, please try again in a few moments.');
      commit('setIsLoading', false);
    });
  },
  customAddPage({ commit }, args = null) {
    commit('setIsLoading', true);
    return folderService.getItems(args).then((response) => {
      commit('addItemPage', response.data.results);
      commit('updateItemsCount', response.data.count);
      commit('setIsLoading', false);
      commit('setAllFolderImage', response.data.last_updated_image);
      commit('setSharedFolderImage', response.data.shared_collages_image);
      return response;
    });
  },
};

extendedFolderStore.mutations = {
  ...extendedFolderStore.mutations,
  setAllFolderImage(state, image) {
    state.allFolderImage = image;
  },
  setSharedFolderImage(state, image) {
    state.sharedCollageImage = image;
  },
};

export const folders = extendedFolderStore;
